import React, { useState, useEffect } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";
import LoadingPopup from "./loading";

const MySwal = withReactContent(Swal2);

const SendLeadsDetails = (props) => {
  const [loading, setLoading] = useState(true);
  const [sendLeads, setSendLeads] = useState([]);
  const [sendTable, setSendTable] = useState([]);
  const [sendSum, setSendSum] = useState("");
  const [statuses, setStatuses] = useState([]);

  const fetchSendLeads = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getSendLeads", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSendLeads(data);
        var arr = [];
        var sum = 0;
        props.clients.map((client) => {
          var send = data.filter((s) => +s.companyId === +client.id);
          var companyName = client.name;
          var companyMail = client.mail;
          var price = client.price;
          var id = client.id;
          var leads = props.leads.filter(
            (lead) => send.filter((s) => +s.leadId === +lead.id).length === 0
          );
          var leadsNon = props.leads.filter(
            (lead) => send.filter((s) => +s.leadId === +lead.id).length > 0
          );
          var leadsNon2 = [];
          leadsNon.map((lead) => {
            var obj = {
              lead: lead,
              date: send.filter((s) => +s.leadId === +lead.id)[0].assDate,
            };
            leadsNon2.push(obj);
          });
          var obj = {
            leads: leads,
            leadsNon: leadsNon2,
            name: companyName,
            mail: companyMail,
            price: price,
            id: id,
          };
          arr.push(obj);
          sum = sum + price * leads.length;
        });
        console.log(arr);
        setSendSum(sum);
        setSendTable(arr);
        fetchStatuses();
      })
      .catch((error) => {});
  };

  const fetchStatuses = async () => {
    var body = {};

    await fetch("https://apisellcrm.ftpeople.pl/getStatuses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setStatuses(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchSendLeads();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: "5vh",
          left: "5vw",
          width: "80vw",
          maxHeight: "80vh",
          overflowY: "scroll",
          backgroundColor: "white",
          boxShadow: "8px 8px 24px 0px rgba(66, 68, 90, 1)",
          borderRadius: "15px",
          padding: "2%",
        }}
      >
        {loading ? (
          <LoadingPopup />
        ) : (
          <>
            <div style={{ display: "flex", marginBottom: "3vh" }}>
              <div
                style={{
                  width: "85%",
                  textAlign: "left",
                  fontWeight: "600",
                  fontSize: "2vw",
                }}
              >
                WYSYŁKA KONTAKTÓW - {sendSum ? sendSum + " zł netto" : ""}
              </div>
              <div style={{ width: "15%" }}>
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "navy",
                    borderColor: "navy",
                    width: "100%",
                  }}
                  onClick={() => {
                    props.close();
                  }}
                >
                  X
                </button>
              </div>
            </div>
            <div style={{ textAlign: "left" }}>
              {sendTable.map((client) => (
                <>
                  <p style={{ fontWeight: "900" }}>
                    {client.name} - {client.mail}
                  </p>
                  <div style={{ paddingLeft: "10px" }}>
                    {client.leads.map((lead) => (
                      <p>{lead.name}</p>
                    ))}
                  </div>
                  <p
                    style={{
                      textTransform: "uppercase",
                      fontSize: ".8vw",
                      fontWeight: "900",
                    }}
                  >
                    Wartość wysyłki: {client.price * client.leads.length} zł
                    netto
                  </p>
                  {client.leadsNon.length > 0 ? (
                    <div style={{ fontSize: ".8vw" }}>
                      <p style={{ color: "red", textTransform: "lowercase" }}>
                        Usunięte z wysyłki - duplikaty
                      </p>
                      <div style={{ paddingLeft: "10px", color: "red" }}>
                        {client.leadsNon.map((lead) => (
                          <p>
                            {lead.lead.name} - {lead.date}
                          </p>
                        ))}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>
            <div style={{ width: "20%", marginTop: "3vh" }}>
              {sendTable.filter((el) => el.leads.length > 0).length > 0 ? (
                <button
                  className="loginButtonLogin"
                  value="yes"
                  style={{
                    margin: "0",
                    backgroundColor: "green",
                    borderColor: "green",
                    width: "100%",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    var model = [];
                    statuses.map((el) => {
                      model[el.name] = el.name;
                    });

                    MySwal.fire({
                      title: "Wybierz wartość",
                      input: "select",
                      inputOptions: model,
                      inputPlaceholder: "wybierz wartość",
                      showCancelButton: true,
                      cancelButtonText: "Anuluj",
                      inputValidator: function (value) {
                        return new Promise(function (resolve, reject) {
                          if (value !== "") {
                            resolve();
                          } else {
                            resolve("musisz wybrać wartość");
                          }
                        });
                      },
                    }).then(async function (result) {
                      if (result.isConfirmed) {
                        var body = {
                          sendTable: sendTable,
                          type: props.sendOption,
                          status: result.value,
                        };
                        fetch("https://apisellcrm.ftpeople.pl/sendLeads", {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: secretKey,
                          },
                          body: JSON.stringify(body),
                        })
                          .then((response) => response.text())
                          .then((data) => {})
                          .catch((error) => {});
                        MySwal.fire({
                          icon: "success",
                          title: "Wysłano",
                          text: "kontakty",
                        }).then(async (result) => {
                          props.close();
                        });
                      }
                    });
                  }}
                >
                  WYŚLIJ
                </button>
              ) : (
                ""
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SendLeadsDetails;
